export default {
    state: {
        wallet: null,
        modals: {
            subscribe: false,
            wallet: false
        },
        token: {
            token_symbol: 'ETH'
        },
        landLordInfo: {
            myRef: '',
            numRefBonus: 0
        },
        presaleStarted: false,
        saleStatus: 'pre',
        mainsaleStarted: false,
        multiSelect: false
    },
    mutations: {
        setAccount(state, payload) {
            state.wallet = {
                address: payload.account.address,
                type: payload.wallet,
                balance: payload.account.balance
            };
        },
        setLandLord(state, payload) {
            state.landLordInfo = payload.landLordInfo;
        },
        clearAccount(state) {
            state.wallet = null;
            state.landLordInfo = {
                myRef: '',
                numRefBonus: 0
            }
        },
        closeModal(state, payload) {
            state.modals[payload] = false;
        },
        openModal(state, payload) {
            state.modals[payload] = true;
        },
        setBalance(state, payload) {
            if (state.wallet == null) {
                return;
            }
            state.wallet.balance = payload;
        },
        setToken(state, payload) {
            state.token = payload;
        },
        setPresaleStarted(state, payload) {
            state.presaleStarted = payload;
        },
        setSaleStatus(state, payload) {
            state.saleStatus = payload;
        }
    }
};
